export default __webpack_public_path__ + "static/media/o2o.dc2c9fe6.svg";